/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Icon } from '@components/atoms'
import { List, ListItemButton, Collapse } from '@components/molecules'

interface PropsType {
	id: string
	className?: string
	title?: string
	renderItem?: JSX.Element
	chevronAlign?: 'left' | 'right'
	isOpen?: boolean
	onIsOpen?: (id: string) => void
	disabled?: boolean
	style?: React.CSSProperties
	children?: React.ReactNode
}

export const CollapsibleListItem = (props: PropsType) => {
	// state
	const [isOpen, setIsOpen] = React.useState(false)

	// variables
	const chevronAlign: 'left' | 'right' = props.chevronAlign ?? 'right'

	const onClick = React.useCallback(() => {
		if (props.isOpen !== undefined && props.onIsOpen !== undefined) {
			props.onIsOpen(props.id)
		} else {
			setIsOpen(!isOpen)
		}
	}, [props.isOpen, props.id, props.onIsOpen, isOpen])

	return (
		<View css={style}>
			<ListItemButton
				className={`listItemButton ${props.className ?? ''}`}
				css={[
					chevronAlign === 'left' ? { paddingLeft: '1.5rem' } : null,
					{ ...props.style },
				]}
				onClick={onClick}
				disabled={props.disabled}
			>
				{props.renderItem !== undefined ? (
					<View>{props.renderItem}</View>
				) : (
					<Text category="p1">{props.title ?? ''}</Text>
				)}
				<Icon
					className="chevronIcon"
					css={chevronAlign === 'right' ? { right: '1rem' } : { left: 0 }}
					name={props.isOpen ?? isOpen ? 'chevron-down' : 'chevron-right'}
				/>
			</ListItemButton>

			<Collapse in={props.isOpen ?? isOpen} timeout="auto" className="collapse">
				<List disablePadding>{props.children}</List>
			</Collapse>
		</View>
	)
}

const style = css({
	'.listItemButton': {
		position: 'relative',
		height: 'fit-contents',

		'.chevronIcon': {
			position: 'absolute',
		},
	},

	'.collapse': {},
})
